import * as React from "react";
import {ListRequest} from "../../../../generated/protocol";
import {PagerModel} from "../../list/PagerModel";
import {EntityDataTable} from "../../list/EntityDataTable";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {UserGroupService, USER_GROUP_SERVICE_NAME} from "../../../service/admin/UserGroupService";
import {RouterView, LoadingViewState} from "../RouterView";
import {ListUtils} from "../../list/ListUtils";

interface State extends LoadingViewState {
    listRequest?: ListRequest;
}

export class UserGroupListView extends RouterView<{}, State> {
    columns = [
        {property: "nameId", name: "ID", orderBy: "ID"},
        {property: "name", name: "Name", orderBy: "name"}
    ];

    userService: UserGroupService;

    constructor(props) {
        super(props);
        this.userService = AppCtx.resolve<UserGroupService>(USER_GROUP_SERVICE_NAME);
        this.state = {loading: false, listRequest: {offset: 0, limit: 0, ascending: false, orderBy: "id"}};
    }

    loadContent(): Promise<any> {
        return undefined;
    }

    onPagerChange(pager: PagerModel) {
        var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({listRequest: listRequest});
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>User Groups</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated fadeInRight">
                    <EntityDataTable
                        service={this.userService}
                        onPagerChange={this.onPagerChange.bind(this)}
                        columns={this.columns}
                        listRequest={this.state.listRequest}
                    />
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/user/UserGroupListView.tsx